module.exports = __webpack_public_path__ + "car_1.f136da16cbf96b7f22c98e09b09e35c4.svg";